module.exports = __webpack_public_path__ + "img/gPay.df36deb2.svg";